module.exports = __webpack_public_path__ + "static/allgemein1_neu-ff2753659993bab08d1336ef92559595.png";